/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolMagicWandIcon20Solid = forwardRef('ToolMagicWandIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M12 12a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M12.884 7.116a1.25 1.25 0 0 1 0 1.768l-9 9a1.25 1.25 0 0 1-1.768-1.768l9-9a1.25 1.25 0 0 1 1.768 0Z" }),
        React.createElement("path", { d: "M17.657 3.757a1 1 0 0 0-1.414-1.414L14.12 4.464a1 1 0 0 0 1.415 1.415l2.12-2.122Z" }),
        React.createElement("path", { d: "M6.343 2.343a1 1 0 0 1 1.414 0L9.88 4.464A1 1 0 0 1 8.464 5.88l-2.12-2.122a1 1 0 0 1 0-1.414Z" }),
        React.createElement("path", { d: "M14.121 10.121a1 1 0 0 1 1.415 0l2.12 2.122a1 1 0 0 1-1.413 1.414l-2.122-2.121a1 1 0 0 1 0-1.415Z" }),
        React.createElement("path", { d: "M19 9a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2h3Z" }),
        React.createElement("path", { d: "M7 9a1 1 0 1 0 0-2H5a1 1 0 0 0 0 2h2Z" })));
});
